module.exports = __webpack_public_path__ + "img/icon02.a5243603.png";